import { createGetDataReducer } from "./CommonReducer";
import {EMAILTEMPLATEGET , EMAILTEMPLATEDETAILS , EMAILTEMPLATEUPDATE} from '../../Constants/EmailTemplate'



export const EmailTemplateGetReducer = createGetDataReducer(EMAILTEMPLATEGET );
export const EmailTemplateDetailsReducer = createGetDataReducer(EMAILTEMPLATEDETAILS);
export const EmailTemplateUpdateReducer = createGetDataReducer(EMAILTEMPLATEUPDATE)



